import { useMemo } from 'react';
import { makeRootClassName, makeBEM } from '../../../utils';
export var useDividerClassNames = function useDividerClassNames(classPrefix, className, props) {
  var _ref = props || {},
      horizontal = _ref.horizontal,
      vertical = _ref.vertical;

  return useMemo(function () {
    var baseClassNames = makeRootClassName(classPrefix, className);
    var stateClassNames = [];

    if (horizontal) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'horizontal'));
    }

    if (vertical) {
      stateClassNames.push(makeBEM(classPrefix, 'Root', 'vertical'));
    }

    return {
      Root: "".concat(baseClassNames, " ").concat(stateClassNames.join(' ')).trim()
    };
  }, [classPrefix, className, horizontal, vertical]);
};